import { Button } from "@mui/material";
import { colors } from "../../ui/colors";
import { useCalendarDateSelectorState, useSetCalendarDateSelector } from "../states/useCalendarDateSelector";

interface CalendarClearButtonProps {
  onClear: () => void;
}

export function CalendarClearButton({ onClear }: CalendarClearButtonProps) {
  const { range } = useCalendarDateSelectorState();
  const { setPayload } = useSetCalendarDateSelector();

  const hasActiveFilter = !!(range.start || range.end);

  if (!hasActiveFilter) return null;

  const handleClear = () => {
    setPayload({ range: { start: null, end: null }, showCard: false });
    onClear();
  };

  return (
    <Button
      fullWidth
      variant="text"
      onClick={handleClear}
      sx={{
        color: "var(--fx-surface-texttertiary, #94A3B8)",
        textTransform: "none",
        fontWeight: 800,
        fontSize: 12,
        py: 1,
        borderRadius: 2,
        bgcolor: "var(--fx-surface-base, #FFFFFF)",
        "&:hover": {
          bgcolor: "rgba(255, 107, 0, 0.05)",
          color: colors.orange.base,
        },
      }}
    >
      Clear Filters
    </Button>
  );
}
